/**
 * Guía: Avisos (diálogos de ingreso).
 *
 * Reglas decididas el 2026-10-12 (Figma v2, página 22; backend
 * `docs/IN_APP_NOTICES.md`). Lo que más confunde al operarlo es el tope: un
 * aviso publicado no garantiza que todos lo vean ese día.
 */

import type { TourFlow } from '../types';

const AVISOS_PATH = '/in-app-notices';

export const c33bAvisos: TourFlow = {
  id: 'admin.in-app-notices',
  chapter: '33b',
  title: 'Avisos',
  summary:
    'El diálogo que la app muestra al abrir: tipos, prioridad y por qué no todos lo ven el mismo día.',
  href: AVISOS_PATH,
  requiresCountry: true,
  estimatedMin: 3,
  steps: [
    {
      id: 'intro',
      title: 'Uno al abrir, uno al día',
      body:
        'Un aviso es un diálogo que la app muestra al abrir: un evento con su código, un ' +
        'bono que llegó, un cambio de reglamento o las novedades de una versión. **Cada ' +
        'cliente ve como mucho uno al día**; solo el de bono se salta ese tope.',
      route: AVISOS_PATH,
    },
    {
      id: 'priority',
      title: 'Cuando coinciden, gana el tipo',
      body:
        'Bono, luego reglamento, luego evento, luego novedades. Entre dos del mismo tipo, ' +
        'el de mayor prioridad. Por eso un evento publicado puede tardar un día en salirle ' +
        'a quien ese día tenía un cambio de reglamento pendiente.',
      target: 'admin.in-app-notices.table',
      placement: 'top',
      optionalTarget: true,
    },
    {
      id: 'automatic',
      title: 'Los automáticos se arman solos',
      body:
        'Con origen «al acreditar un bono», el sistema lo muestra a cada cliente que recibió ' +
        'ese bono en los últimos 14 días, con el monto en el texto. Con «al actualizar la ' +
        'app», solo a quien venía de una versión anterior.',
    },
    {
      id: 'publish',
      title: 'Publicar y la push',
      body:
        'Publicado, sale desde su fecha de inicio. Si marcaste la push, se envía **una sola ' +
        'vez, al publicar**, y no se deshace. Un aviso publicado no se borra: se archiva, ' +
        'porque el registro de a quién se le mostró es la evidencia de que se informó.',
    },
    {
      id: 'filters',
      title: 'Estados',
      body:
        'Programado es publicado que aún no empieza; Terminado, publicado que ya pasó su ' +
        'fecha. El listado es del país seleccionado.',
      target: 'admin.in-app-notices.filters',
      placement: 'bottom',
      optionalTarget: true,
    },
  ],
};
